import { useSearchParams } from 'react-router'

import { VIEWINGS_VIEW_PARAM } from './useRentalPortalViewingsViewRegime.constants'
import { getViewingsViewRegime } from './useRentalPortalViewingsViewRegime.utils'

export function useRentalPortalViewingsViewRegime() {
  const [searchParams, setSearchParams] = useSearchParams()

  const listViewType = getViewingsViewRegime(searchParams)

  function handleChangeViewType(view) {
    setSearchParams(
      params => {
        const nextParams = new URLSearchParams(params)

        nextParams.set(VIEWINGS_VIEW_PARAM, view)

        return nextParams
      },
      { replace: true }
    )
  }

  return { handleChangeViewType, listViewType }
}
